import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'wilson-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ImpressumComponent {}
